import { useMemo } from "react";
import { useQuery } from "convex/react";
import { convexApi } from "../convexApi";
import { demoDataForViewer, readDemoViewerId } from "../lib/demoSession";
import type { LexData } from "../lib/types";

export type LexDataState =
  | { status: "loading"; title: string; body: string }
  | { status: "ready"; data: LexData };

export function useLexData(mode: "convex" | "demo"): LexDataState {
  if (mode === "demo") return { status: "ready", data: demoDataForViewer(readDemoViewerId()) };

  return useConvexLexData();
}

function useConvexLexData(): LexDataState {
  const access = useQuery(convexApi.bootstrap.getAccessStatus, {});
  const data = useQuery(convexApi.bootstrap.getAppData, access?.status === "active" ? {} : "skip");

  return useMemo(() => {
    if (access === undefined) {
      return {
        status: "loading",
        title: "Checking access...",
        body: "Confirming your LexMosaic member account.",
      };
    }

    if (access.status !== "active") {
      return {
        status: "loading",
        title: access.title,
        body: access.body,
      };
    }

    if (data === undefined) {
      return {
        status: "loading",
        title: "Opening LexMosaic...",
        body: "Loading your private member workspace.",
      };
    }
    return { status: "ready", data: data as LexData };
  }, [access, data]);
}
